<template>
    <div class="button">
        <router-link :to="router">
            <the-language :de="de" :en="en" />
        </router-link>
    </div>
</template>

<style lang="scss" scoped>

    .button{
        @apply px-4 py-2 text-white my-4 lowercase inline-block;
        background: rgb(201,60,38);
        background: linear-gradient(32deg, rgba(201,60,38,1) 50%, rgba(212,99,81,1) 50%);
        transition: all ease-in-out 0.2s;
        box-shadow: 0px 0px 33px -15px rgba(0,0,0,0);
        cursor: pointer;
        &:hover{
            box-shadow: 0px 0px 33px -15px rgba(0,0,0,0.75);
        }
    }
</style>
<script>
    import TheLanguage from './TheLanguage'

    export default {
        name: 'TheButtonLink',
        components: {
            TheLanguage
        },

        props: {
            de: {
                type: String,
                default: () => {
                }
            },
            en: {
                type: String,
                default: () => {
                }
            },
            router: {
                type: String,
                default: () => {
                }
            }
        }
    }

</script>
